import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const OpportunityPriorityInput = () => {
  const { priorityId = '' } = useParams();
  const decodedId = priorityId ? atob(priorityId) : priorityId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityPriority';

  useEffect(() => {
    if (priorityId) { setIsEditing(true); fetchDetails(); }
  }, [priorityId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['opportunityPriority'] + id + '/', { headers });
      setFormData(response.data?.data ?? response.data);
    } catch (error) { console.error('Error fetching Opportunity Priority details:', error); }
  };

  const fields = [{"name":"name","label":"Name","type":"text"},{"name":"level","label":"Level","type":"number"},{"name":"description","label":"Description","type":"textarea"}];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Priority' : 'Create Opportunity Priority'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunityPriorityInput;